(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mer-pdp-treatments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    "use strict";

    function say(root, text) {
      var live = root.querySelector("[data-pick-status]");
      if (live) live.textContent = text;
    }

    function onSubmit(e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches("[data-pick-form]")) return;
      var cart = window.MerCart;
      /* No cart script on the page: let the plain form post go through. */
      if (!cart || typeof cart.addToCart !== "function") return;
      e.preventDefault();

      var root = form.closest("[data-mer-pick]") || document;
      var btn = form.querySelector("[data-pick-add]");
      var label = form.querySelector("[data-pick-label]");
      var idField = form.querySelector('input[name="id"]');
      var id = idField ? parseInt(idField.value, 10) : 0;
      if (!id || !btn || btn.disabled) return;

      var idle = btn.getAttribute("data-label") || "Add";
      var done = (root.getAttribute && root.getAttribute("data-added-label")) || "Added";
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");

      cart.addToCart(id, 1).then(function () {
        if (label) label.textContent = done;
        btn.classList.add("is-done");
        say(root, done);
        window.setTimeout(function () {
          if (label) label.textContent = idle;
          btn.classList.remove("is-done");
          btn.disabled = false;
        }, 1800);
      }).catch(function (err) {
        var msg = (err && err.message) || "Could not add that to your cart.";
        btn.disabled = false;
        say(root, msg);
        if (typeof cart.toast === "function") cart.toast(msg);
      }).then(function () {
        btn.removeAttribute("aria-busy");
      });
    }

    if (!window.__merPickBound) {
      window.__merPickBound = true;
      document.addEventListener("submit", onSubmit);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mer-pdp-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    "use strict";
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function init(root) {
      if (!root || root.__merUgc) return;
      root.__merUgc = true;
      var track = root.querySelector("[data-ugc-track]");
      var nav = root.querySelector("[data-ugc-nav]");
      var prev = root.querySelector("[data-ugc-prev]");
      var next = root.querySelector("[data-ugc-next]");
      if (!track) return;

      function cards() { return track.querySelectorAll("[data-ugc-card]"); }

      function sync() {
        var max = track.scrollWidth - track.clientWidth;
        var x = Math.abs(track.scrollLeft);
        if (nav) nav.hidden = max <= 4;
        if (prev) prev.disabled = x <= 4;
        if (next) next.disabled = x >= max - 4;
      }

      /* A fallback asset that is not in the theme would show as a broken image: drop that card. */
      function drop(img) {
        var card = img.closest ? img.closest("[data-ugc-card]") : null;
        if (card && card.parentNode) card.parentNode.removeChild(card);
        if (!cards().length) root.hidden = true;
        sync();
      }
      Array.prototype.forEach.call(track.querySelectorAll("img"), function (img) {
        if (img.complete && img.naturalWidth === 0 && img.currentSrc) drop(img);
        else img.addEventListener("error", function () { drop(img); });
      });

      function step(dir) {
        var first = cards()[0];
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
        var w = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        var n = Math.max(1, Math.floor(track.clientWidth / w) - 1);
        track.scrollBy({ left: dir * w * n, behavior: reduce ? "auto" : "smooth" });
      }
      if (prev) prev.addEventListener("click", function () { step(-1); });
      if (next) next.addEventListener("click", function () { step(1); });

      var ticking = false;
      track.addEventListener("scroll", function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });
      window.addEventListener("resize", sync);
      sync();
    }

    function boot(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll("[data-mer-ugc]"), init);
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
    else boot();
    document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
